// @flow
export type FeatureOptions = {
    [key: string]: any,
};

export type FeatureConfig = {
    [key: string]: FeatureOptions,
};
